import { useAuth } from "@/orbit/context/AuthContext";
import { Building2, Users, Handshake, Activity, Lock } from "lucide-react";

const upcomingPhases = [
  { icon: Building2, label: "Accounts", phase: "Phase 1", desc: "Company records with contacts and deal history" },
  { icon: Users, label: "Contacts", phase: "Phase 1", desc: "Individual leads with a unified activity timeline" },
  { icon: Activity, label: "Campaigns & Activities", phase: "Phase 2", desc: "Multi-channel outreach and engagement tracking" },
  { icon: Handshake, label: "Deals", phase: "Phase 3", desc: "Kanban pipeline with unified 7-stage flow" },
];

export default function Dashboard() {
  const { user, workspace } = useAuth();
  return (
    <div className="max-w-6xl" data-testid="orbit-dashboard-page">
      <div className="flex items-baseline justify-between">
        <div>
          <p className="text-[11px] uppercase tracking-[0.22em] text-[#1E40AF] font-semibold">Dashboard</p>
          <h1 className="mt-2 text-3xl font-semibold text-[#0A1F44]">
            Welcome, {user?.first_name} <span className="text-slate-400">·</span> <span className="text-slate-500 text-2xl">{workspace?.name}</span>
          </h1>
          <p className="mt-2 text-sm text-slate-500">
            Your workspace is ready. Foundation modules are being rolled out in phases.
          </p>
        </div>
      </div>

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-4">
        {upcomingPhases.map(({ icon: Icon, label, phase, desc }) => (
          <div key={label} className="bg-white border border-slate-200 rounded-md p-6 flex items-start gap-4 relative" data-testid={`orbit-phase-card-${label.toLowerCase().replace(/[ &]+/g, '-')}`}>
            <div className="w-10 h-10 bg-slate-100 text-slate-700 rounded-md flex items-center justify-center shrink-0">
              <Icon className="w-4 h-4" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <h3 className="font-semibold text-[#0A1F44]">{label}</h3>
                <span className="text-[10px] uppercase tracking-[0.18em] font-semibold text-slate-400 bg-slate-100 px-2 py-0.5 rounded">{phase}</span>
              </div>
              <p className="mt-1.5 text-sm text-slate-500">{desc}</p>
            </div>
            <Lock className="w-4 h-4 text-slate-300 shrink-0" />
          </div>
        ))}
      </div>

      <div className="mt-10 bg-[#0A1F44] text-white rounded-md p-6">
        <p className="text-[11px] uppercase tracking-[0.22em] text-blue-300 font-semibold">Phase 0 — Foundation shipped</p>
        <h3 className="mt-2 text-xl font-semibold">Authentication, workspaces, and team management are ready.</h3>
        <p className="mt-2 text-sm text-white/70">
          Invite teammates from Settings → Team. Manage workspace settings from Settings → Workspace. Phase 1 (Accounts + Contacts + Activity Timeline) will build on top of this foundation.
        </p>
      </div>
    </div>
  );
}
